<template>
    <v-container>
        <v-toolbar dense flat color="transparent">
            <v-toolbar-title class="font-weight-bold">Locations</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row>
            <v-col cols="4">
                <v-form ref="createForm">
                    <v-card>
                        <v-card-text>
                            <div class="subtitle-2">Name</div>
                            <v-text-field
                                v-model="newItem.name"
                                required
                                :rules="[v => !!v || 'This is required']"
                                outlined
                                hide-details="auto"
                                dense
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <div class="subtitle-2">Category</div>
                            <v-select
                                v-model="newItem.category_id"
                                :items="categories"
                                required
                                :rules="[v => !!v || 'This is required']"
                                dense
                                outlined
                                hide-details="auto"
                                item-text="name"
                                item-value="id"
                            ></v-select>
                        </v-card-text>
                        <v-card-text>
                            <div class="subtitle-2">Description</div>
                            <v-textarea
                                v-model="newItem.description"
                                required
                                :rules="[v => !!v || 'This is required']"
                                outlined
                                hide-details="auto"
                                dense
                            ></v-textarea>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="lime darken-4" @click="onSubmit">Add Location</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
            <v-col cols="8">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :items-per-page="10"
                    :loading="loading"
                    :options.sync="tableOptions"
                    :server-items-length="totalItems"
                    :sort-by="defaultOrdering.column"
                    :sort-desc="defaultOrdering.descending"
                    multi-sort
                    class="elevation-1"
                >
                    <template v-slot:item="row">
                        <tr
                            class="tm-pointer"
                            @click="$router.push('/settings/location/'+row.item.id)"
                        >
                            <td>
                                <v-checkbox></v-checkbox>
                            </td>
                            <td>{{ row.item.name }}</td>
                            <td>{{ row.item.category.name }}</td>
                            <td>{{ $moment(row.item.created_at).format('DD-MM-YYYY HH:mm:ss') }}</td>
                            <td>{{ $moment(row.item.updated_at).format('DD-MM-YYYY HH:mm:ss') }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="snackbar"
            color="success"
            bottom
            right
            :timeout="5000"
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            modelPath: "locations",
            newItem: {
                name: "",
                category_id: "",
                description: ""
            },
            categories: [],
            tableOptions: {},
            totalItems: 0,
            headers: [
                {
                    text: "",
                    value: ""
                },
                {
                    text: "Name",
                    value: "name"
                },
                {
                    text: "Category",
                    value: "category__name"
                },
                {
                    text: "Created At",
                    value: "created_at"
                },
                {
                    text: "Updated At",
                    value: "updated_at"
                }
            ],
            defaultOrdering: {
                column: ["created_at"],
                descending: [true]
            },
            items: [],
            loading: false,
            snackbar: false,
            snackbarMessage: null
        };
    },
    computed: {
        ordering() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
            let ordering = "";
            if (sortBy)
                sortBy.forEach((val, index, arr) => {
                    ordering += ordering ? "," : "";
                    ordering += (sortDesc[index] ? "-" : "") + val;
                });
            return ordering;
        }
    },
    watch: {
        tableOptions: {
            handler() {
                this.getListOfItems().then(data => {
                    this.items = data.items;
                    this.totalItems = data.total;
                    this.loading = false;
                });
            },
            deep: true
        }
    },
    created() {
        this.getListOfItems().then(data => {
            this.items = data.items;
            this.totalItems = data.total;
            this.loading = false;
        });
        this.getListOfCategories().then(data => {
            this.categories = data.items;
            this.loading = false;
        });
    },
    methods: {
        onSubmit: function() {
            if (this.$refs.createForm.validate()) {
                //TODO :- Perform action if the form is validated
                this.postCreateNewItem().then(res => {
                    this.items.push(res.data);
                    this.snackbarMessage = "Location created successfully!"
                    this.snackbar = true
                });
            }
        },
        getListOfCategories: function() {
            return new Promise(resolve => {
                this.$http({
                    method: "get",
                    url: `/categories`
                })
                    .then(function(response) {
                        console.log(response.data);
                        let items = response.data.results;
                        resolve({
                            items
                        });
                    })
                    .catch(function(err) {
                        console.log(err.response);
                    });
            });
        },
        getListOfItems: function() {
            return new Promise(resolve => {
                const {
                    sortBy,
                    sortDesc,
                    page,
                    itemsPerPage
                } = this.tableOptions;
                this.loading = true;

                this.$http({
                    method: "get",
                    url: `/${this.modelPath}`,
                    params: {
                        page: page,
                        itemsPerPage: itemsPerPage,
                        ordering: this.ordering
                    }
                })
                    .then(function(response) {
                        console.log(response.data);
                        let items = response.data.results;
                        const total = response.data.count;
                        resolve({
                            items,
                            total
                        });
                    })
                    .catch(function(err) {
                        console.log(err.response);
                    });
            });
        },
        postCreateNewItem: function() {
            return new Promise(resolve => {
                this.$http({
                    method: "post",
                    url: `/${this.modelPath}/`,
                    data: this.newItem
                })
                    .then(response => {
                        console.log(response.data);
                        let data = response.data;
                        resolve({
                            data
                        });

                        this.$refs.createForm.reset();
                    })
                    .catch(function(err) {
                        console.log(err.response);
                    });
            });
        }
    }
};
</script>
